import { getTranslations } from "next-intl/server";

type Variant = "chip" | "banner";

interface ResearchUseBadgeProps {
	variant?: Variant;
}

function WarningIcon({ className = "" }: { className?: string }) {
	return (
		<svg
			aria-hidden
			viewBox="0 0 16 16"
			className={className}
			fill="none"
			stroke="currentColor"
			strokeWidth="1.4"
			strokeLinejoin="round"
		>
			<path d="M8 2 L14.5 13.5 L1.5 13.5 Z" />
			<line x1="8" y1="6" x2="8" y2="10" strokeLinecap="round" />
			<circle cx="8" cy="11.8" r="0.5" fill="currentColor" stroke="none" />
		</svg>
	);
}

export async function ResearchUseBadge({ variant = "chip" }: ResearchUseBadgeProps) {
	const t = await getTranslations("catalog.researchUseBadge");

	if (variant === "banner") {
		return (
			<div className="border-status-soon/40 bg-status-soon/10 flex items-center gap-3 rounded-md border px-4 py-3">
				<WarningIcon className="h-4 w-4 shrink-0 text-status-soon" />
				<p className="font-mono text-[0.7rem] uppercase leading-snug tracking-[0.16em] text-status-soon">
					{t("bannerPrimary")} <span className="text-muted-foreground">{t("bannerSecondary")}</span>
				</p>
			</div>
		);
	}

	return (
		<div className="border-status-soon/35 bg-status-soon/10 flex items-center gap-2 rounded-sm border px-2 py-1">
			<WarningIcon className="h-3 w-3 shrink-0 text-status-soon" />
			<p className="font-mono text-[0.58rem] uppercase leading-tight tracking-[0.14em] text-status-soon">
				{t("chip")}
			</p>
		</div>
	);
}
